/* Search AutoComplete
------------------------------------------------ */
(function($) {

	function outputLi(result) {
		return '<li><a href="' + result.url + '">' + result.title + '</a></li>';
	}

    $.fn.autoKomplete = function(options) {
		this.each(function(){
			var el = $(this), keyTimer, previousValue;
			var submitBtn = el.siblings('button[type="submit"]');

			var thisForm = $(el).closest('form');
			var resultsEl = thisForm.find('.predictive-search-results');
			let currentJsonRequest = null;

			var opt = $.extend({
				type: false
			}, options );

			thisForm.on('submit', function(){
				clearTimeout(keyTimer);
				thisForm.removeClass('is-loading search-done');
				if (currentJsonRequest) {
					currentJsonRequest.abort();
				}
				resultsEl.hide();
			});

			el.on('keyup', function(event){

				if( event.which == 9 || event.which == 16 ){ // ignore tab/shift
					return false;
				}

				if(previousValue != el.val()) {
					clearTimeout(keyTimer);

					if(el.val() && el.val().length >= 2) {
						keyTimer = setTimeout(getResults, 100);
					} else {
						thisForm.removeClass('is-loading prediction-active search-done');
						resultsEl.fadeOut(200);
					}
				}

				previousValue = el.val();

			});

			function getResults() {
				thisForm.addClass('is-loading');

				var jsonURL = local_var.rest_url + 'frierlevitt/search?term=' + el.val();
				if(opt.type) {
					jsonURL += '&type=' + opt.type;
				}

				currentJsonRequest = $.getJSON(jsonURL, (results) => {

					var output = '';

					if(results.length) {
						output += '<ul class="clear-list-styles">';
						$.each(results, function(i, v){
							if(i == 6) {
								return false;
							}
							output += outputLi(v);
							console.log(i);
						});
						output += '</ul>';
						if(results.length > 6) {
							output += '<div class="button-wrap"><button type="submit" class="see-all-btn clear-btn-styles">See all results</button></div>';
						}
					}

					resultsEl.html(output);
					thisForm.removeClass('is-loading').addClass('search-done');
					if(results.length) {
						resultsEl.fadeIn(200);
						thisForm.addClass('prediction-active');
					} else {
						thisForm.removeClass('prediction-active');
						resultsEl.hide();
					}
				});
			}
		});
    };

}(jQuery));

(function ($) {
	// On Dom Ready
	$(function () {

		// Predictive Search
		$('.predictive-search input[name="s"]').autoKomplete();
		$('.predictive-search.attorney-search input[name="keyword"]').autoKomplete({type: 'attorney'});
		$('.predictive-search.service-search input[name="keyword"]').autoKomplete({type: 'service'});

	});
})(jQuery);
